import { useContext, useState } from "react";
import "../../assets/AdminCss/Login.css";

import { useNavigate } from "react-router-dom";
import { AuthContext, base_url } from "../../context/Authcontext";
import axios from "axios";
import toast from "react-hot-toast";
const AdminLogin = () => {
  const [phoneNumber, setPhoneNumber] = useState();
  const [password, setPassword] = useState();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { phoneNumber, password };
      if (!phoneNumber || !password) {
        toast.error("Please fill all fields");
        return;
      }
      const res = await axios.post(`${base_url}/api/webapi/adminlogin`, data, {
        headers: {
          Accept: "application/json",
        },
      });
      // console.log("admin login response is", res);
      if (res.data.status) {
        localStorage.setItem("admin", res.data.value);
        localStorage.setItem('role',res.data.role);
        localStorage.setItem('phoneNumber', res.data.phoneNumber);
        navigate("/admin/dashboard");
        toast.success(res.data.message);
        return;
      }else{
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      alert("An error occured during login");
    }
  };

  return (
    <div className="bgcc">
      <div className="van-overlay"></div>
      <div className="Loading">Loading...</div>
      <form
        className="login-main-bx"
        style={{ transform: "translate(0%,41%)" }}
        onSubmit={handleSubmit}
      >
        <div className="logo_intop">
          <img
           src="/assets/images/logo.svg"
            className="logo-bx boxlogin bg-white py-2 px-2"
            alt=""
          />
        </div>
        <div className="form-group form-group-default">
          <label className="lab-user my-2">Phone Number</label>
          <div className="controls">
            <input
              type="text"
              id="phone_number_inp"
              placeholder="Phone Number"
              className="input-bx"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required=""
            />
          </div>
        </div>

        <div className="form-group form-group-default">
          <label className="lab-user my-2">Password</label>
          <div className="controls">
            <input
              type="password"
              id="password_inp"
              placeholder="Password"
              className="input-bx"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required=""
            />
          </div>
        </div>

        <div className="form-group my-2">
          <input type="checkbox" id="remember_me" />
          <label for="remember_me" className="remember-me-text">
            Remember me
          </label>
        </div>

        <button type="submit" id="login_button" className="btn-in-bx">
          Login
        </button>
      </form>
      <span id="PING_IFRAME_FORM_DETECTION" style={{ display: "none" }}></span>
    </div>
  );
};

export default AdminLogin;